{
  "_note": "Pro Runde wird eine Karte aus dem Pool gezogen und zu Beginn angekündigt. Aufgelöst wird am Rundenende; das Budget-Delta gilt für die nächste Runde.",
  "pools": [
    ["energy_price", "co2_price"],
    ["vs_request"],
    ["supplier_epd", "co2_price", "energy_price"]
  ],
  "events": {
    "energy_price": {
      "title": "Strompreis-Schock",
      "text": "Die Strompreise ziehen kräftig an. Wer eigenen Strom erzeugt oder effizient arbeitet, spart bares Geld.",
      "hint": "Gewappnet mit: PV aufs Dach oder LED & Druckluft",
      "requires_any": ["pv", "efficiency"],
      "success": { "budget": 2, "text": "Eingesparte Stromkosten fließen ins Klimabudget." },
      "failure": { "budget": -1, "text": "Höhere Stromkosten belasten das Budget." }
    },
    "co2_price": {
      "title": "CO2-Preis steigt",
      "text": "Mit dem europäischen Emissionshandel ETS 2 werden Erdgas und Diesel teurer.",
      "hint": "Gewappnet mit: Wärmepumpe oder E-Fuhrpark",
      "requires_any": ["heat_pump", "e_fleet"],
      "success": { "budget": 2, "text": "Weniger fossile Energie – weniger CO2-Kosten." },
      "failure": { "budget": -2, "text": "Die CO2-Kosten für Gas und Diesel steigen." }
    },
    "vs_request": {
      "title": "Großkunde fragt nach Ihren Klimadaten",
      "text": "Ihr wichtigster Kunde berichtet nach CSRD und bittet Sie um Ihre Treibhausgasdaten – im Rahmen des freiwilligen VS-Standards (früher VSME).",
      "hint": "Gewappnet mit: Klimabilanz Scope 1–3",
      "requires_any": ["carbon_accounting"],
      "success": { "budget": 3, "text": "Sie liefern sofort – der Kunde verlängert den Rahmenvertrag." },
      "failure": { "budget": -2, "text": "Hektische Nacharbeit mit externer Hilfe kostet Budget." }
    },
    "supplier_epd": {
      "title": "Lieferant liefert eine EPD",
      "text": "Ein Hauptlieferant stellt eine Umweltproduktdeklaration (EPD) mit echten Primärdaten bereit.",
      "hint": "Gewappnet mit: Lieferanten-Klimaziele",
      "requires_any": ["supplier_dialog"],
      "success": { "budget": 2, "text": "Primärdaten statt Durchschnittswerte: Ihre Bilanz wird belastbarer." },
      "failure": { "budget": 0, "text": "Ohne Lieferantendialog bleibt die EPD in der Schublade." }
    }
  }
}
